export default {
  zh: 'CN',
  en: 'EN',
  save: 'Save',
  cancel: 'Cancel',
  confirm: 'Confirm',
  user: 'User',
  logout: 'Sign out',
  info: 'Basic Information',
  workInfo: 'Job Information',
  job: 'Occupation Information',
  setting: 'Security Setting',
  account: 'Account Information',
  email: 'Email',
  phone: 'Mobile',
  emailBind: 'You have bound a email',
  phoneBind: 'You have bound a mobile',
  password: 'Password',
  setted: 'Created',
  passwordTip: 'A high-security password can make the account more secure. It is recommended that you change your password regularly and set a password which contains at least two of letters, symbols or numbers and is longer than 6 digits.',
  third: 'Third party account',
  office: 'Office365 account',
  weChat: 'Wechat account',
  boundAccount: 'Bound accounts',
  bound: 'Bind',
  remove: 'Unbind',
  follow: 'Follow Wechat public account ',
  followInfo: 'Scan the QR code and follow the Wechat official account for the latest news',
  followed: 'Followed account',
  upload: 'Upload',
  noBound: 'Unbound',
  noBoundEmail: 'Unbound Email',
  noBoundPhone: 'Unbound Phone',
  imageCropping: 'Upload cover',
  choosePicture: 'Select picture',
  basic: {
    last: 'First name',
    first: 'Last name',
    middle: 'Middle name',
    full: 'Full name',
    en: 'English name',
    used: 'Former name',
    gender: 'Gender',
    birth: 'Date of birth',
    nationality: 'Nationality',
    documentType: 'ID type',
    certificateNumber: 'ID No.',
    phone: 'School tel',
    email: 'Email',
    homeTel: 'Family tel',
    address: 'Address'
  },
  work: {
    id: 'ID',
    status: 'Job status',
    position: 'Job title',
    time: 'Join date'
  },
  position: {
    id: 'ID',
    work: 'Occupation',
    company: 'Company'
  },
  title: {
    title1: 'Tip',
    title2: 'Binding confirmation',
    title3: 'Please enter a email',
    title4: 'Please enter a mobile no.',
    title5: 'Please complete identity verification to confirm it is your own operation',
    title6: 'Please enter a new email',
    title7: 'Please enter a new mobile no.'
  },
  tip: {
    email: 'Email',
    phone: 'Mobile no.',
    code: 'Verified code',
    getCode: 'Get verified code',
    new: 'New password',
    confirm: 'Confirm password',
    tips0: 'Please enter a correct email',
    tip1: 'Do you confirm to unbind？',
    tip2: 'You can login the system with the third party account after binding',
    tip3: 'Bound successfully！',
    tip4: 'Verified successfully，do you confirm to bind？'
  },
  choose: {
    tip1: 'Please select',
    tip2: 'Please select',
    tip3: 'Please select',
    tip4: 'Please select',
    tip5: 'Please select'
  }
}



// WEBPACK FOOTER //
// ./src/views/user/lang/en.js